import { useTranslation } from "@hireroo/i18n";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import * as React from "react";

import EmployeeLayout, { EmployeeLayoutProps } from "../../layouts/EmployeeLayout/EmployeeLayout";

const StyledHeaderStack = styled(Stack)(() => ({
  alignItems: "center",
  justifyContent: "space-between",
}));

export type QuestionListProps = {
  layout: EmployeeLayoutProps;
  SearchArea: React.ReactNode;
  QuestionTable: React.ReactNode;
};

const QuestionList: React.FC<QuestionListProps> = props => {
  const { t } = useTranslation();
  const layoutProps: EmployeeLayoutProps = {
    ...props.layout,
  };

  return (
    <EmployeeLayout {...layoutProps}>
      <Box p={3}>
        <StyledHeaderStack direction="row" alignItems="center" justifyContent="space-between" mb={2} spacing={2}>
          <Stack direction="row" justifyContent="space-between">
            <Stack spacing={1.5}>
              <Typography variant="h5" fontWeight={700} noWrap>
                {t("問題一覧")}
              </Typography>
              <Typography fontSize={14} color="textSecondary">
                {t(
                  "問題はコーディング形式、実践形式、クイズ形式、システムデザイン形式、ライブコーディング形式の中から選んで出題することが可能です。そのうち、コーディングテストで出題可能な問題はライブコーディング形式を除く4つの問題形式から出題することが可能です。お使いのプランによってはご利用いただけない問題形式もあります。",
                )}
              </Typography>
            </Stack>
          </Stack>
        </StyledHeaderStack>

        <Box>
          <Stack spacing={2}>
            {props.SearchArea}
            {props.QuestionTable}
          </Stack>
        </Box>
      </Box>
    </EmployeeLayout>
  );
};

QuestionList.displayName = "QuestionList";

export default QuestionList;
